import type { DefaultErrorProps } from '@grandvisionhq/www-next/pages/error'

export const defaultErrorProps: DefaultErrorProps = {
  title: 'OOOPS !',
  subheader:
    'Il semblerait que la page ou le produit que vous cherchez soit introuvable. Toutes nos excuses pour la gêne occasionnée. Nous vous invitons à effectuer une nouvelle recherche.',
  buttonText: 'Retour au site',
}
